import { useEffect, useState } from 'react';
import { Dashboard } from './pages/dashboard';
import { SettingsPanel } from './pages/settings-panel';

type Route = 'dashboard' | 'settings-panel' | 'unknown';

const resolveRoute = (pathname: string): Route => {
  if (pathname.startsWith('/dashboard')) return 'dashboard';
  if (pathname.startsWith('/settings-panel')) return 'settings-panel';
  return 'unknown';
};

export const App = () => {
  const [route, setRoute] = useState<Route>(() => resolveRoute(window.location.pathname));

  useEffect(() => {
    const onPopState = () => setRoute(resolveRoute(window.location.pathname));
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  if (route === 'dashboard') {
    return <Dashboard />;
  }

  if (route === 'settings-panel') {
    return (
      <>
        <SettingsPanel />
      </>
    );
  }

  return (
    <div className="flex h-full items-center justify-center p-8 text-center">
      <div>
        <h1 className="text-xl font-semibold">Givebutter for Wix</h1>
        <p className="mt-2 text-sm text-gray-500">
          This URL is intended to be loaded by Wix. Visit <code>/dashboard</code> or{' '}
          <code>/settings-panel</code> directly for local testing.
        </p>
      </div>
    </div>
  );
};
